// React
import React, { useState, useEffect, useContext, useMemo } from "react";
// React
// CSS
import styles from "./QuestionCreatorQuestionViewer.module.css";
// CSS
// Models
import { I_QuizMakerQuestions } from "../../Models/interfaces";
// Models
// Components
import QuestionCard from "./QuestionCard/QuestionCard";
import { Fade } from "react-awesome-reveal";
// Components
// Services
import { sendAnswersOfQuestionsService } from "../../Services/Quiz/post/sendAnswersOfQuestionsService";
// Services
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router";
import { LessonDataContext } from "../../Contexts/LessonDataContext";
import { toast } from "react-toastify";
import QuestionReports from "./QuestionCard/QuestionReports/QuestionReports";
import QuestionModalForShowQuestion from "./QuestionCard/QuestionModalForShowQuestion/QuestionModalForShowQuestion";
import { BiArrowBack } from "react-icons/bi";
// Contexts

type QuestionCreatorQuestionViewerProps = {
  questions: I_QuizMakerQuestions[];
  setIsNeedFullScreenNeed: React.Dispatch<React.SetStateAction<boolean>>;
};

const QuestionCreatorQuestionViewer: React.FunctionComponent<
  QuestionCreatorQuestionViewerProps
> = ({ questions, setIsNeedFullScreenNeed }) => {
  const [questionAndAnswer, setQuestionAndAnswer] = useState<
    {
      qId: string;
      aId: string;
    }[]
  >([]);

  const { state } = useLocation();
  const lessonData = useContext(LessonDataContext);
  const [reportData, setReportData] = useState<string>("");
  const [isReportInScreen, setIsReportInScreen] = useState<boolean>(false);

  const [isImageModalInScreen, setIsImageModalInScreen] =
    useState<boolean>(false);
  const [modalData, setModalData] = useState<string>("");

  const answeredQuestionsCount = useMemo(() => {
    return questionAndAnswer.filter((item) => item.aId !== "0").length;
  }, [questionAndAnswer]);

  useEffect(() => {
    setQuestionAndAnswer(
      questions.map((item) => ({ aId: "0", qId: String(item.id) }))
    );
  }, [questions]);

  useEffect(() => {
    setIsNeedFullScreenNeed(true);

    return () => {
      setIsNeedFullScreenNeed(false);
    };
  });

  const _questions = useMemo(() => {
    if (!questions) return;
    return questions.map((item, index) => (
      <Fade key={item.id} triggerOnce>
        <QuestionCard
          question={item}
          onAnswerSelect={(aId) => {
            const copyOfQuestionAndAnswer = [...questionAndAnswer];

            const selectedIndex = copyOfQuestionAndAnswer.findIndex(
              (qCombo) => qCombo.qId === String(item.id)
            );

            if (
              String(copyOfQuestionAndAnswer[selectedIndex].aId) === String(aId)
            ) {
              copyOfQuestionAndAnswer[selectedIndex].aId = String(0);
              console.log("removed");
              setQuestionAndAnswer(copyOfQuestionAndAnswer);
              return "removed";
            }
            console.log("selected");
            copyOfQuestionAndAnswer[selectedIndex].aId = String(aId);
            setQuestionAndAnswer(copyOfQuestionAndAnswer);
            return "selected";
          }}
          isSelected={
            questionAndAnswer.find((_item) => _item.aId === String(item.id))
              ?.aId ?? ""
          }
          currQuestion={index + 1}
          currLessonName={
            state.currMode === "full"
              ? String(item.lesson_name)
              : lessonData?.lessonName
          }
          setModalData={setModalData}
          setIsModalInScreen={setIsImageModalInScreen}
        />
      </Fade>
    ));
  }, [questions, questionAndAnswer, lessonData?.lessonName, state.currMode]);

  const userToken = useContext(UserTokenContext);
  const navigate = useNavigate();
  return (
    <div
      className={`${styles.questionCreatorContainer} pt-4 dark:!text-black`}
      style={{
        paddingBottom: "10vh",
      }}
    >
      {isReportInScreen ? (
        <>
          <QuestionReports
            setIsReportInScreen={setIsReportInScreen}
            selectedAnswers={questionAndAnswer}
            data={((): string[] => {
              const splitedData = reportData
                .replace(/<br\s*\/?>/gi, "testToChangeTheResponse")
                .split("testToChangeTheResponse");

              return splitedData;
            })()}
          />
        </>
      ) : (
        <></>
      )}
      {isImageModalInScreen ? (
        <>
          {isImageModalInScreen ? (
            <QuestionModalForShowQuestion
              questionImageUrl={modalData}
              setIsModalInScreen={setIsImageModalInScreen}
            />
          ) : null}
        </>
      ) : (
        <></>
      )}
      <div
        className="flex flex-row-reverse items-center justify-between relative p-4 "
        onClick={() => {
          navigate(-1);
        }}
      >
        <span>برای بازگشت ضربه بزنید</span>
        <BiArrowBack className="text-2xl" />
      </div>
      {questions.length === 0 ? <>آزمون انتخابی سوالی ندارد</> : _questions}
      <div
        className={`${styles.fixedBottom} w-full ${
          window.innerWidth > 600 ? "left-auto" : "left-0"
        } bottom-0 fixed flex flex-col items-end justify-between pr-4`}
        style={{
          bottom: "6vh",
        }}
      >
        <button
          className={`${styles.submitBtn} p-3 w-12 h-12 text-white text-xs flex items-center justify-center  -mt-5  absolute left-3 top-0 rounded-full`}
          onClick={() => {
            Swal.fire({
              icon: "question",
              title: "از پایان آزمون مطمئن هستید ؟",
              showCancelButton: true,
              confirmButtonText: "پایان آزمون",
              cancelButtonText: "لغو",
            }).then(({ isConfirmed, isDenied, isDismissed }) => {
              if (isDenied || isDismissed) return;
              if (isConfirmed) {
                toast("درحال آماده سازی پاسخ ها لطفا صبر کنید");
                sendAnswersOfQuestionsService(
                  userToken,
                  questionAndAnswer.map((item) => item.qId).toString(),
                  questionAndAnswer.map((item) => item.aId).toString(),
                  0,
                  questionAndAnswer.length
                ).then(({ data }) => {
                  console.log(data);
                  console.log(
                    "",
                    data.darsad
                      .replace(/<br\s*\/?>/gi, "testToChangeTheResponse")
                      .split("testToChangeTheResponse")
                    // .map((item: string) => {
                    //   return {
                    //     percentage: item.replace(
                    //       /class="([^"]*lesson_darsad_res[^"]*)"/,
                    //       ""
                    //     ),
                    //   };
                    // })
                  );
                  setReportData(data.darsad);

                  // const x = String(
                  //   data.darsad.replace(/(<([^>]+)>)/gi, "")
                  // ).split(":");

                  Swal.fire({
                    icon: "info",
                    title: "نتیجه ی آزمون ",
                    showConfirmButton: true,
                    confirmButtonText: "مشاهده پاسخنامه",
                    cancelButtonText: "مشاهده کارنامه",
                    showCancelButton: true,
                  }).then(({ isConfirmed, isDenied }) => {
                    if (isConfirmed) {
                      navigate("/quiz-maker/show-answers", {
                        state: {
                          selectedAnswers: questionAndAnswer.map(
                            (item) => item.aId
                          ),
                          currMode: state.currMode,
                        },
                      });
                      return;
                    }
                    if (isDenied) {
                      setIsReportInScreen(true);
                    } else {
                      setIsReportInScreen(true);
                      return;
                    }
                  });
                });
                return;
              }
            });
          }}
        >
          پایان
        </button>
        <button
          className={`${styles.pdfBtn} p-3 w-12 h-12  text-white text-xs flex items-center justify-center  -mt-5  absolute left-20 top-0 rounded-full`}
          onClick={() => {
            navigate("/profile/pdf-maker", {
              state: {
                currMode: state.currMode,
                quizId: state.quizId,
                lessonName: lessonData?.lessonName,
              },
            });
          }}
        >
          PDF
        </button>

        <>
          <p className="text-xs">{state.lessonData}</p>
          <p className="text-xs">
            <span>سوالات پاسخ داده شده : </span>
            <span>{answeredQuestionsCount}</span>
          </p>
          <p className="text-xs">
            <span>سوالات باقی مانده : </span>
            <span>{questions.length - answeredQuestionsCount}</span>
          </p>
        </>
      </div>
    </div>
  );
};

export default QuestionCreatorQuestionViewer;
